<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Course Unit` : "Add Course Unit" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12"
            ><v-autocomplete
              v-model="form.course_id"
              :items="courses"
              item-text="name"
              item-value="id"
              label="Course*"
              outlined
              :append-icon="course_id ? '' : 'mdi-menu-down'"
              :readonly="course_id ? true : false"
              dense
              hide-details="auto"
              :rules="[rules.required]"
            ></v-autocomplete
          ></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.name"
              label="Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.unit_no"
              label="Unit Number*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.number]"
          /></v-col>
          <v-col
            ><div id="app">
              <label>Description* </label>
              <vue-editor
                v-model.trim="form.description"
                :editorToolbar="customToolbar"
                :rules="[rules.required]"
              ></vue-editor></div
          ></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary white--text" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import { rules } from "@/helpers/rules";

export default {
  components: {
    VueEditor,
  },
  props: {
    section: {
      type: Object,
      default: () => {},
    },
    courses: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    course_id: {
      type: Number,
      default: () => null,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {
        department_id: null,
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike", "blockquote", "code-block"], // basic styles
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ size: ["small", "normal", "large", "huge"] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        [{ script: "sub" }, { script: "super" }],
        [{ color: [] }, { background: [] }],
        ["clean"], // remove formatting button
      ],
    };
  },
  computed: {},
  created() {
    this.init();
    if (this.course_id) {
      this.form.course_id = this.course_id;
    }
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.section };
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.form.active = true;
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
